import { SupportedFileType } from "../../file";
import { PhotoCaptureAttributeType } from '../enums';
export const PhotoCaptureConstants = {
    PREVIOUS: 'Prev',
    NEXT: 'Next',
    COMMENT_BUTTON: 'Add/View Comments',
    PROCEED_BUTTON: 'Proceed',
    GET_STARTED: 'Get Started',
    BACK: 'Back',
    GENERIC_PHOTO_CAPTURE: 'Generic Photo Capture',
    ACCEPT_TNC: 'I accept the Terms and Conditions.',
    I_DECLINE: 'I Decline',
    TERMS_OF_USE: 'Terms Of Use',
    PRIVACY_POLICY: 'Privacy Policy',
    ANSWER_TEXT_ACCEPT: 'accept',
    ANSWER_TEXT_DECLINE: 'decline',
    ANSWER_TEXT_DEFAULT: 'Default',
    Y: 'Y',
    N: 'N',
    TAKE_PHOTO: 'Take Photo',
    ICON_CLASS: 'mi-icon-camera',
    ADD_PHOTO_ICON_CLASS: 'mi-icon-photo-add',
    LIKE_ICON_CLASS: 'mi-icon-thumbsup',
    ALERT_FILL_CIRCLE_ICON_CLASS: 'mi-icon-alert-filled-circle',
    ICON_VIDEO_CLASS: 'mi-icon-video',
    ZERO_STRING: '0',
    CLOSEUP_SHOT_IMAGE_COUNT: 3,
    FOUR_CORNERS_IMAGE_COUNT: 4,
    FINISH: 'Finish',
    PHOTO_CAPTURE_APPLICATION_NAME: 'Guided Photo Capture',
    GPC_PHOTO_CAPTURE: 'Photo Capture - Guided Photos',
    GPC_REQUEST_ADDITIONAL: 'Photo Capture - Request Photos',
    PBE_PHOTO_CAPTURE: 'Photo Estimating - Guided Photos',
    PBE_REQUEST_ADDITIONAL: 'Photo Estimating - Request Photos',
    MAX_IMAGE_FILE_SIZE: 15728640,
    ICON_ATTACHMENT_CLASS: 'mi-icon-attachment-add',
    RECORD_VIDEO: 'Record Video',
    RETAKE_VIDEO: 'Retake Video',
    SAVE: 'Save',
    I_UNDERSTAND: 'I UNDERSTAND',
    STATE_FRAUD_WARNING: 'State Fraud Warning',
    VIDEOLIMIT_WARNING: "We're sorry, something went wrong. Please contact your insurance provider to turn on this feature.",
    THUMBNAIL_MAX_SIZE: 350,
    PERMANENTLY_DELETE: 'Permanently delete',
    YES: 'Yes',
    NO: 'No',
    ACCEPT_IMAGE_MIME: 'image/*',
    ACCEPT_VIDEO_MIME: 'video/*',
    SCAN_IN: 'Scan VIN',
    VIN_DETAIL_QUESTION_TEXT: 'Please confirm your vehicle details',
    VIN_LENGTH: 17,
    MILEAGE_LENGTH: 9,
    LICENSE_LENGTH: 10,
    EN_US: 'en-US',
    SELECT: 'Select',
    SELECT_FR: 'Sélectionner',
    ADD_PHOTOS: 'Add Additional Photos',
    ADD_COMMENTS: 'Add Comments',
    UPLOADED_PHOTOS: 'Uploaded Photos',
    DELETE: 'Delete',
    FR_CA: 'fr-CA',
    SP_ES: 'es-ES',
    DEFAULT_FOLDER_TYPE_ID: '0',
    SUBMIT: 'Submit',
    PROCEED: 'Proceed',
    NO_RECORD_FOUND: 'No Shops in the area specified. Kindly try for a new area or simply submit the photos without selecting a shop.',
    SHOP_NAME: 'Shop Name',
    ADDRESS: 'Address',
    BODY_SHOP: 'bodyShop',
    SELECT_SHOP_LANDING_MESSAGE: 'Here are some repair facilities we have found near you.',
    DOWNLOAD_SELECTED: 'Download Selected',
    DOWNLOAD_ALL: 'Download All',
    DOWNLOAD_IMAGES: 'Download Images',
    SELECT_SHOP_MESSAGE: 'Shop Selection Complete! Your repair request has been submitted to your preferred shop.',
    SHOP_NOT_SELECT_MESSAGE: 'Shop has not been selected. However, you can still proceed and submit the images/artifacts',
    SKIP: 'Skip'
};
export const PhotoCaptureAllowedMimeTypeConstant = [
    SupportedFileType.PNG,
    SupportedFileType.JPEG,
    SupportedFileType.JPG,
    SupportedFileType.GIF
];
export const PhotoCaptureServiceHeader = {
    applicationName: 'Self-serve',
    sourceName: 'Photo Capture - Guided Photos',
    saveToEds: 'true'
};
export const FILE_INPUT_ICON_SIZE = 35;
export const THUMBNAIL_HEIGHT = '70px';
export const THUMBNAIL_WIDTH = '70px';
export const VIDEO_WIDTH = '100%';
export const PhotoCaptureFileExtensionAllowedForGallery = [
    SupportedFileType.MP3,
    SupportedFileType.WMA,
    SupportedFileType.WAV,
    SupportedFileType.AIFF,
    SupportedFileType.AAC,
    SupportedFileType.M4P,
    SupportedFileType.MSV,
    SupportedFileType.DVF,
    SupportedFileType.RA,
    SupportedFileType.DSS,
    SupportedFileType.JPG,
    SupportedFileType.JPEG,
    SupportedFileType.GIF,
    SupportedFileType.DOC,
    SupportedFileType.DOCX,
    SupportedFileType.PDF,
    SupportedFileType.TXT,
    SupportedFileType.RTF,
    SupportedFileType.XLS,
    SupportedFileType.XLSX,
    SupportedFileType.CSV,
    SupportedFileType.PNG,
    SupportedFileType.TIFF,
    SupportedFileType.TIF
];
export const PhotoCaptureFileExtensionForAllowedPdf = [
    SupportedFileType.JPG,
    SupportedFileType.JPEG,
    SupportedFileType.PDF
];
export const PhotoCaptureVideoMimeTypesConstant = [
    SupportedFileType.AVI,
    SupportedFileType.MP4,
    SupportedFileType.MPEG,
    SupportedFileType.MOV,
    SupportedFileType.MPG,
    SupportedFileType.WMV
];
export const RequestAdditionalErrorMessage = {
    INVALID_FILE_TYPE: 'Valid extension(s)',
    MAX_FILE_SIZE_EXCEEDED: 'Maximum file size support is'
};
export const ADDITIONAL_PHOTOS_TEXT = 'Additional Photos requested for';
export const NOTE = 'Note';
export const FOUR_CORNER_SIDES = {
    FRONT_LEFT: 'Front Left',
    FRONT_RIGHT: 'Front Right',
    BOTTOM_LEFT: 'Bottom Left',
    BOTTOM_RIGHT: 'Bottom Right'
};
export const THREE_CORNER_SIDES = {
    TOP_CLOSEUP: 'Top Close-Up',
    CENTER_CLOSEUP: 'Center Close-Up',
    BOTTOM_CLOSEUP: 'Bottom Close-Up'
};
export const DAMAGE_PANEL = {
    DAMAGE: 'Damage',
    ADDITIONAL_PHOTOS: 'Additional Photos',
    TWISTY_LABEL: 'Wide Damage',
    ICON_EDIT_CLASS: 'mi-icon-edit',
    ICON_DELETE_CLASS: 'mi-icon-delete',
    CLEAR: 'Clear',
    ADD_MORE_PANEL: 'Add More Damages',
    RENAME_ERROR_MESSAGE: 'Group Name already exists, please enter a different group name.',
    ADD_MORE_PANEL_ID: 'add_more_damages_id',
    DAMAGE_NAME_ID: 'damage_name_id',
    ICON_ADD_MORE_CLASS: 'mi-icon-complete-filled-circle'
};
export const CONFIRMATION_MODAL_TITLE = {
    HEADING_TITLE: 'Confirm this action?',
    INNER_CONTENT: 'Are you sure you want to Clear/Delete this Panel? All the images/comments uploaded for this panel will also be deleted',
    SELECT_SHOP_DESCRIPTION_FIRST: "The carrier has already pre-selected a shop for you. If you want to continue with the carrier's choice then tap or finish.",
    SELECT_SHOP_DESCRIPTION_SECOND: 'If you want to select a different shop, you can click on proceed.'
};
export const PROGRESSIVE_CO_CODES = ['IF', 'Z5', 'X8'];
export const DOWNLOAD_ARTIFACTS_MESSAGES = {
    DOWNLOAD_NOT_APPLICABLE_ERROR: 'Either download is not allowed from editing portal or task is not closed',
    REACTIVATION_LIMIT_EXPIRED: 'Reactivation Limit Expired',
    NO_IMAGES_FOUND: 'No Images Uploaded'
};
export const downloadAartifactsGalleryProps = {
    tilesGap: '1px',
    smallTileWidth: '70px',
    smallTileHeight: '70px'
};
export const PRG_QUESTIONS_SUB_TYPE = [
    PhotoCaptureAttributeType.WIDE_ENHANCED,
    PhotoCaptureAttributeType.CLOSEUP_ENHANCED
];
//# sourceMappingURL=PhotoCaptureConstants.js.map